module.exports = require('./helpers/bundle-url').getBundleURL('eaJHN') + "loader.40e04524.svg";